import { TokensIcon } from '@radix-ui/react-icons'
import {
  DoorOutIcon,
  TransactionsIcon,
  SettingIcon,
  UserIcon,
  ReferralNavIcon
} from 'shared/icons'

export const PROFILE_LINK_ICONS = {
  PROFILE_ICON: UserIcon,
  LOGOUT_ICON: DoorOutIcon,
  TRANSACTIONS_ICON: TransactionsIcon,
  SETTINGS_ICON: SettingIcon,
  ACCOUNT_ICON: UserIcon,
  BONUS_ICON: TokensIcon,
  REFERRAL_ICON: ReferralNavIcon
}
